import * as Sentry from '@sentry/browser';
import React from 'react';
import { ErrorView } from './ErrorView';
import { logErrorToDataDog } from './logErrorToDataDog';

export class ErrorBoundary extends React.Component {
    state = {
        error: false,
        errorMessage: null,
    };

    componentDidCatch(error, info) {
        logErrorToDataDog();

        const errorMessage = `${
            error ? error.toString() : 'React did not provide an error object.'
        }`;
        const stack = info ? info.componentStack : 'Stack unavailable';

        this.setState({
            error: true,
            errorMessage: `${errorMessage}\n${stack}`,
        });

        if (typeof window !== 'undefined') {
            const { SENTRY_DSN } = window && window.ZD ? window.ZD.configs : {};
            const toLog =
                error && error instanceof Error ? error : errorMessage;
            if (SENTRY_DSN) {
                Sentry.withScope((scope) => {
                    scope.setTags({ isFullPageCrash: true });
                    scope.setExtras({ info });
                    Sentry.captureException(toLog);
                });
            }
        }
    }

    render() {
        if (this.state.error) {
            return (
                <ErrorView
                    errorCode={500}
                    errorMessage={this.state.errorMessage}
                />
            );
        }

        return this.props.children;
    }
}
